import type { SettlementRepository } from '../repository/SettlementRepository';
import type { CommissionSearchRequest, CommissionSearchResponse } from '../entity/SettlementTypes';

export class SearchCommissionsUseCase {
  constructor(private readonly repository: SettlementRepository) {}

  async execute(request: CommissionSearchRequest): Promise<CommissionSearchResponse> {
    if (!request.params || request.params.length === 0) {
      throw new Error('검색 파라미터가 필요합니다.');
    }
    if (!request.local_field) {
      throw new Error('local_field가 필요합니다.');
    }
    if (!request.from) {
      throw new Error('from이 필요합니다.');
    }
    return this.repository.searchCommissions(request);
  }
}

